/** Return an available dashboard title using the familiar "(2)" suffix. */
export function getUniqueDashboardTitle(title: string, existingTitles: string[]): string {
  const requested = title.trim()
  if (!requested) return requested

  const occupied = new Set(existingTitles.map((value) => value.trim().toLocaleLowerCase()))
  if (!occupied.has(requested.toLocaleLowerCase())) return requested

  const suffixMatch = requested.match(/^(.*)\s+\((\d+)\)$/)
  const base = suffixMatch?.[1]?.trim() || requested
  let suffix = suffixMatch ? Number(suffixMatch[2]) + 1 : 2
  while (occupied.has(`${base} (${suffix})`.toLocaleLowerCase())) suffix += 1
  return `${base} (${suffix})`
}
